module.exports = __webpack_public_path__ + "static/img/beizhengshouhu_02.3f1bdcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/beizhengshouhu_02.png
// module id = Mzyq
// module chunks = 1